import { createAction } from '@reduxjs/toolkit';
import { ADD_COMPARISON_PRODUCT, GET_COMPARISON_PRODUCTS_FAILURE, GET_COMPARISON_PRODUCTS_REQUEST, GET_COMPARISON_PRODUCTS_SUCCESS, REMOVE_ALL_COMPARISON_PRODUCTS, REMOVE_COMPARISON_PRODUCT, SET_INITIAL_COMPARISON_STATE, SET_COMPARISON_ORDER_PRODUCTS, } from './actionTypes';
const getComparisonProductsRequest = createAction(GET_COMPARISON_PRODUCTS_REQUEST);
const getComparisonProductsSuccess = createAction(GET_COMPARISON_PRODUCTS_SUCCESS);
const getComparisonProductsFailure = createAction(GET_COMPARISON_PRODUCTS_FAILURE);
export const addComparisonProduct = createAction(ADD_COMPARISON_PRODUCT);
export const removeComparisonProduct = createAction(REMOVE_COMPARISON_PRODUCT);
export const removeAllComparisonProducts = createAction(REMOVE_ALL_COMPARISON_PRODUCTS);
export const setInitialComparisonState = createAction(SET_INITIAL_COMPARISON_STATE);
export const setComparisonOrderProducts = createAction(SET_COMPARISON_ORDER_PRODUCTS);
export const requestActions = {
    request: getComparisonProductsRequest,
    success: getComparisonProductsSuccess,
    failure: getComparisonProductsFailure,
};
